import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { ValidationResponse } from '../types';

type UsernameValidationField = 'username';

type UsernameValidationError = 'username' | 'user_not_allowed' | 'user_taken' | 'user_too_short' | 'user_too_long';

export const validateUsername = async (username: string) => {
    const url = pathfinder('validate_username');

    return axios.post<ValidationResponse<UsernameValidationField, UsernameValidationError>>(url, { username });
};
